<script>
    import { TimeFormat } from 'api/moment'
    import { serverDateTime } from 'store/server'
    import { isInputToggled, isWaterMark, isPlayer, isHelp, isPhone } from 'store/hud'
    import keys from 'store/keys'
    import keysName from 'json/keys.js'
    import { charWanted, charMoney, charBankMoney, charFractionID, charOrganizationID, charData } from 'store/chars'
    import CustomKey from './Key.svelte'
    import { format } from 'api/formatter'
    import CountUp from 'api/countup';
    import { weatherName, formatTime, getWeatherIdToName } from '../phonenew/components/weather/data'
    export let mapwidth;
    export let marginhun;

    let selectCharData = $charData;

    // export let SafeSone;

    let isWorld = true;
    window.hudStore.isWorld = (value) => isWorld = value;

    let direction = "NE";
    window.hudStore.direction = (value) => direction = value;

    // Зелёная зона: над картой остаётся только постоянный значок «БЕЗОПАСНО».
    // Само событие входа/выхода — обычное уведомление сервера, как и всё
    // остальное: один канал, одно место на экране.
    let greenZone = false;
    let greenZoneKnown = false;
    window.hudStore.greenZone = (value) => {
        value = !!value;
        if (greenZoneKnown && value !== greenZone && window.notificationAdd)
            window.notificationAdd(value ? 2 : 0, 9,
                value ? 'Вы вошли в зелёную зону' : 'Вы вышли из зелёной зоны', 3000);
        greenZoneKnown = true;
        greenZone = value;
    };

    let bodycam = false;
    window.hudStore.bodycam = (value) => bodycam = value;

    let street = "";
    window.hudStore.street = (value) => street = value;

    let area = "";
    window.hudStore.area = (value) => area = value;

    
    let polygon = 0;
    window.hudStore.polygon = (value) => polygon = value;

    let radio = 0;
    window.hudStore.radio = (value) => radio = value;

    
    // ID игрока и онлайн живут в store/server и рисуются в бренд-блоке (lchud).
    // Здесь они не выводятся — прежний перехват сеттеров только затирал значения.

    let improvementTime = -1;
	window.hudStore.setImprovementTime = (value) => improvementTime = value;

    let seconds = 0;
    let timer;
    let isRunning = false;

    function start() {
        if (!isRunning) {
        const startTime = Date.now() - seconds * 1000;
        timer = setInterval(() => {
            seconds = Math.floor((Date.now() - startTime) / 1000);
        }, 100);
        isRunning = true;
        }
    }

    function stop() {
        clearInterval(timer);
        isRunning = false;
    }

    function reset() {
        clearInterval(timer);
        seconds = 0;
        isRunning = false;
    }
</script>

<div class="magicnotimap" style="width: {mapwidth + marginhun}px">
    <!-- {#if mapwidth > 0} -->
        {#if improvementTime > 0}
            <div class="hudevo__improvements">
                <img src="/src/views/player/hudevo/images/improvement.svg" alt="">
                <p>{ improvementTime }</p>
            </div>
        {/if}
        {#if bodycam}
        <div class="bodicammaj" style="width: {mapwidth}px">
            <div class="iconbc">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.75 8.4375H6.09375C5.3171 8.4375 4.6875 9.0671 4.6875 9.84375V20.1562C4.6875 20.9329 5.3171 21.5625 6.09375 21.5625H18.75C19.5267 21.5625 20.1562 20.9329 20.1562 20.1562V9.84375C20.1562 9.0671 19.5267 8.4375 18.75 8.4375Z" fill="#939599"/>
                    <path d="M25.3125 10.3126V19.6876C25.3126 19.7701 25.2911 19.8513 25.2499 19.9228C25.2088 19.9944 25.1495 20.0539 25.0781 20.0954C25.0068 20.1362 24.9259 20.1573 24.8438 20.1563C24.7617 20.1567 24.6809 20.1357 24.6094 20.0954L21.0938 18.0704V11.9297L24.6094 9.90475C24.6813 9.86552 24.7619 9.84497 24.8438 9.84497C24.9256 9.84497 25.0062 9.86552 25.0781 9.90475C25.1495 9.94619 25.2088 10.0057 25.2499 10.0773C25.2911 10.1489 25.3126 10.23 25.3125 10.3126Z" fill="#939599"/>
                </svg>
            </div>
            <div class="infobc">
                <h1>bodycam #11</h1> <!--{selectCharData.UUID}-->
                <p>Rec from 2025-07-22 17:23:34</p>
                <p>{seconds} c начала записи</p> <!--{seconds}-->
            </div>
            <div class="zapbc">
                <span></span>
            </div>
        </div>
        {/if}
    <!-- {/if} -->
</div>
<div class="bottomgps">
    {#if greenZone && mapwidth > 0}
            <div class="magicZZ" style="margin-left: -{mapwidth}px">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_151)">
                    <path d="M10.808 1.42695L6.10108 0.0148363C6.03518 -0.00494544 5.96491 -0.00494544 5.89901 0.0148363L1.19196 1.42695C1.11955 1.44867 1.05607 1.49317 1.01094 1.55382C0.96581 1.61448 0.941438 1.68807 0.941437 1.76367V6.94139C0.941437 7.61484 1.21409 8.30424 1.75176 8.99041C2.16241 9.51448 2.73056 10.0407 3.44037 10.5545C4.6328 11.4177 5.80699 11.9472 5.8564 11.9693C5.90158 11.9895 5.95053 12 6.00005 12C6.04956 12 6.09851 11.9895 6.14369 11.9693C6.19308 11.9472 7.36725 11.4177 8.55968 10.5545C9.26948 10.0407 9.83761 9.51448 10.2483 8.99041C10.786 8.30426 11.0586 7.61487 11.0586 6.94139V1.76367C11.0586 1.68807 11.0342 1.61447 10.9891 1.55381C10.9439 1.49315 10.8805 1.44866 10.808 1.42695Z" fill="#74E662"></path>
                    </g>
                    <defs>
                    <clipPath id="clip0_8_151">
                    <rect width="12" height="12" fill="white"></rect>
                    </clipPath>
                    </defs>
                </svg>
                <p>БЕЗОПАСНО</p>
            </div>
    {/if}
</div>
